/*
 * Fallback renderer for Shopify rich text stored as a raw JSON string.
 *
 * `snippets/rich-text-json.liquid` handles this server-side whenever the value reaches
 * Liquid as an object (a `rich_text_field` or `json` metafield). When the value is stored
 * in a plain text field — a multi_line_text_field, or a product body imported by a
 * migration app — Liquid has no way to parse it, so the JSON blob is printed as text.
 * This catches those and renders them in the browser.
 */
(function () {
  var ROOT_PREFIX = '{"type":"root"';

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderInline(nodes) {
    if (!Array.isArray(nodes)) return '';

    return nodes
      .map(function (node) {
        if (node.type === 'text') {
          var text = escapeHtml(node.value || '').replace(/\n/g, '<br>');
          if (node.italic) text = '<em>' + text + '</em>';
          if (node.bold) text = '<strong>' + text + '</strong>';
          return text;
        }

        if (node.type === 'link') {
          var attrs = 'href="' + escapeHtml(node.url || '#') + '"';
          if (node.title) attrs += ' title="' + escapeHtml(node.title) + '"';
          if (node.target) attrs += ' target="' + escapeHtml(node.target) + '" rel="noopener"';
          return '<a ' + attrs + '>' + renderInline(node.children) + '</a>';
        }

        return renderInline(node.children);
      })
      .join('');
  }

  function renderBlocks(nodes) {
    if (!Array.isArray(nodes)) return '';

    return nodes
      .map(function (node) {
        switch (node.type) {
          case 'heading':
            var level = Math.min(Math.max(parseInt(node.level, 10) || 3, 1), 6);
            return '<h' + level + '>' + renderInline(node.children) + '</h' + level + '>';
          case 'paragraph':
            return '<p>' + renderInline(node.children) + '</p>';
          case 'list':
            var tag = node.listType === 'ordered' ? 'ol' : 'ul';
            var items = (node.children || [])
              .map(function (item) {
                return '<li>' + renderInline(item.children) + '</li>';
              })
              .join('');
            return '<' + tag + '>' + items + '</' + tag + '>';
          default:
            return '';
        }
      })
      .join('');
  }

  function upgrade(element) {
    var raw = element.textContent.trim();
    if (raw.indexOf(ROOT_PREFIX) !== 0) return;

    var parsed;
    try {
      parsed = JSON.parse(raw);
    } catch (error) {
      return;
    }

    if (!parsed || parsed.type !== 'root') return;

    var html = renderBlocks(parsed.children);
    if (html) element.innerHTML = html;
  }

  function upgradeAll(scope) {
    (scope || document)
      .querySelectorAll('.product__description, .accordion__content, .rte')
      .forEach(upgrade);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      upgradeAll();
    });
  } else {
    upgradeAll();
  }

  // Section rendering API (variant changes, quick view) replaces this markup.
  document.addEventListener('shopify:section:load', function (event) {
    upgradeAll(event.target);
  });
})();
